import { Fragment } from "react";

export const howItWorks = [
  {
    id: "__howitwork_01__",
    title: <Fragment>Intake</Fragment>,
    description: (
      <Fragment>
        Our coaching process starts with an assessment of your current situation and goals. We want
        to better understand what brought you into coaching. This also allows us to determine who
        among us can best help you. Your expectations, your main concern and reasons for endorsement
        will be discussed to give you a better understanding of what specialized program works best
        for you.
      </Fragment>
    ),
  },
  {
    id: "__howitwork_02__",
    title: <Fragment>360 Degree Feedback</Fragment>,
    description: (
      <Fragment>
        We gather feedback from your peers, and manager to gain a comprehensive understanding of
        your strengths and areas for improvement. This helps us create a personalized development
        plan that addresses your specific needs.
      </Fragment>
    ),
  },
  {
    id: "__howitwork_03__",
    title: <Fragment>Pre and Post Assessments</Fragment>,
    description: (
      <Fragment>
        We use pre-coaching assessments to establish a baseline and identify the areas where you
        need the most improvement. We also use post-coaching assessments to measure your progress
        and determine the impact of our coaching process with the help of your manager and peers.
      </Fragment>
    ),
  },
  {
    id: "__howitwork_04__",
    title: <Fragment>Tailored Fit Coaching Program</Fragment>,
    description: (
      <Fragment>
        Based on your unique needs and goals, we develop a customized coaching program that is
        tailored to fit your specific situation. With our various specializations, we can also make
        your program adaptive as we go through our coaching process and find new areas that needs
        focus on.
      </Fragment>
    ),
  },
  {
    id: "__howitwork_05__",
    title: <Fragment>Coaching Updates to Managers</Fragment>,
    description: (
      <Fragment>
        We provide coaching updates to your managers to ensure that they are informed about your
        progress and the impact of the coaching program on your performance. This helps them provide
        you with additional support and feedback, and creates a culture of ongoing development and
        improvement.
      </Fragment>
    ),
  },
];
